import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from './ui/button';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/assets/cl-heart.png" alt="Connect Legacy" className="h-14 w-14 object-contain" />
            <span className="text-xl font-bold text-gray-900">Connect Legacy</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-gray-600 hover:text-[#7E33E0]" data-testid="back-home-btn">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-3xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 bg-[#7E33E0]/10 rounded-xl flex items-center justify-center">
            <Shield className="h-6 w-6 text-[#7E33E0]" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900">Privacy Policy</h1>
        </div>

        <p className="text-sm text-gray-500 mb-10">Last updated: June 2026</p>

        <div className="space-y-10 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">1. Introduction</h2>
            <p>We value your privacy. This policy explains how we collect and use your details when you sign up for our product waitlist.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">2. What Data We Collect</h2>
            <p>We only collect your name and email address. We do not collect any other personal details.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">3. How We Use Your Data</h2>
            <p className="mb-3">We use your information solely to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Address you personally in our communications.</li>
              <li>Send you updates about your position on the waitlist.</li>
              <li>Notify you when our product launches or when beta testing is available.</li>
            </ul>
            <p className="mt-3">We will never sell your details or share them with third parties for marketing purposes.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">4. Third-Party Services</h2>
            <p>
              We use Resend (Resend Labs Inc.) to securely store and manage our email list. Because Resend is based in the USA, your name and email address will be transferred to and stored on secure servers in the United States. Resend is compliant with the UK and EU-US Data Privacy Frameworks to ensure your data is protected.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-3">5. Your Rights</h2>
            <p>
              You can opt-out at any time. If you want us to permanently delete your information from our list, simply reply to any of our emails or contact us directly, and we will remove it immediately.
            </p>
          </section>

          <section className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Questions or requests? Email us at{' '}
              <a href="mailto:support@connect-legacy.com" className="text-[#7E33E0] hover:underline font-medium">
                support@connect-legacy.com
              </a>
            </p>
          </section>
        </div>
      </main>

      <footer className="bg-gray-950 text-gray-400 py-8 px-4 mt-16">
        <div className="container mx-auto max-w-6xl text-center text-xs">
          © 2026 Connect Legacy. All rights reserved.
        </div>
      </footer>
    </div>
  );
};
